import AdjustSmartLinksControl from '@/js/Controls/AdjustSmartLinksControl'
import AutoRefreshControl from '@/js/Controls/AutoRefreshControl'
import AutoSubmitControl from '@/js/Controls/AutoSubmitControl'
import BrandsFilterFocusControl from '@/js/Controls/BrandsFilterFocusControl'
import BrowserGeolocationControl from '@/js/Controls/BrowserGeolocationControl'
import CarouselControl from '@/js/Controls/CarouselControl'
import ChatControl from '@/js/Controls/ChatControl'
import CollapsableControl from '@/js/Controls/CollapsableControl'
import CopyButtonControl from '@/js/Controls/CopyButtonControl'
import CountdownControl from '@/js/Controls/CountdownControl'
import DailyFeedRationControl from '@/js/Controls/DailyFeedRationControl'
import DropdownControl from '@/js/Controls/DropdownControl'
import EventCallbackControl from '@/js/Controls/EventCallbackControl'
import FilterSelectOptionsControl from '@/js/Controls/FilterSelectOptionsControl'
import FormEnterControl from '@/js/Controls/FormEnterControl'
import FulltextControl from '@/js/Controls/FulltextControl'
import HeaderControl from '@/js/Controls/HeaderControl'
import HomepageAnimalsControl from '@/js/Controls/HomepageAnimalsControl'
import ImageUploadPreviewControl from '@/js/Controls/ImageUploadPreviewControl'
import InputAllowedCharactersControl from '@/js/Controls/InputAllowedCharactersControl'
import LazyloadOnPageLoadControl from '@/js/Controls/LazyloadOnPageLoadControl'
import LinkToTopControl from '@/js/Controls/LinkToTopControl'
import MainMenuControl from '@/js/Controls/MainMenuControl'
import NavBarHighlightControl from '@/js/Controls/NavBarHighlightControl'
import OnCheckFocusControl from '@/js/Controls/OnCheckFocusControl'
import ParameterExpandControl from '@/js/Controls/ParameterExpandControl'
import PhoneGroupControl from '@/js/Controls/PhoneGroupControl'
import PickupPointControl from '@/js/Controls/PickupPointControl'
import ProductBuyBarControl from '@/js/Controls/ProductBuyBarControl'
import QuantityInputControl from '@/js/Controls/QuantityInputControl'
import QuantityDiscountControl from '@/js/Controls/QuantityDiscountControl'
import ScrollToActiveControl from '@/js/Controls/ScrollToActiveControl'
import SelectToLinkControl from '@/js/Controls/SelectToLinkControl'
import SliderControl from '@/js/Controls/SliderControl'
import SmsCodeVerificationControl from '@/js/Controls/SmsCodeVerificationControl'
import TooltipControl from '@/js/Controls/TooltipControl'
import TopNoticesBarControl from '@/js/Controls/TopNoticesBarControl'
import XPlusYDiscountControl from '@/js/Controls/XPlusYDiscountControl'
import { ControlManager } from '@peckadesign/pd-naja'
import naja from 'naja'

const controlManager = new ControlManager(naja)

// Sorted by priority
controlManager.addControlOnLoad(MainMenuControl)
controlManager.addControlOnLive(CollapsableControl)
controlManager.addControlOnLoad(HeaderControl)

controlManager.addControlOnLoad(LazyloadOnPageLoadControl)

controlManager.addControlOnLoad(TopNoticesBarControl)
controlManager.addControlOnLive(CarouselControl)
controlManager.addControlOnLive(ParameterExpandControl)

controlManager.addControlOnLive(ScrollToActiveControl)
controlManager.addControlOnLoad(CountdownControl)
controlManager.addControlOnLoad(ChatControl)
controlManager.addControlOnLive(TooltipControl)
controlManager.addControlOnLoad(NavBarHighlightControl)
controlManager.addControlOnLoad(HomepageAnimalsControl)
controlManager.addControlOnLoad(LinkToTopControl)
controlManager.addControlOnLoad(ProductBuyBarControl)
controlManager.addControlOnLive(DailyFeedRationControl)

controlManager.addControlOnLive(BrowserGeolocationControl)
controlManager.addControlOnLoad(PickupPointControl)

// addControlOnLive inicializuje control i při načtení stránky, samostatná onLoad registrace je zbytečná.
controlManager.addControlOnLive(AdjustSmartLinksControl)

controlManager.addControlOnLive(AutoSubmitControl)
controlManager.addControlOnLive(AutoRefreshControl)
controlManager.addControlOnLoad(CopyButtonControl)
controlManager.addControlOnLive(DropdownControl)
controlManager.addControlOnLoad(FormEnterControl)
controlManager.addControlOnLive(InputAllowedCharactersControl)
controlManager.addControlOnLive(PhoneGroupControl)
controlManager.addControlOnLive(QuantityInputControl)
controlManager.addControlOnLive(QuantityDiscountControl)
controlManager.addControlOnLive(XPlusYDiscountControl)
controlManager.addControlOnLive(SelectToLinkControl)
controlManager.addControlOnLive(SliderControl)
controlManager.addControlOnLive(OnCheckFocusControl)
controlManager.addControlOnLive(SmsCodeVerificationControl)
controlManager.addControlOnLive(FilterSelectOptionsControl)
controlManager.addControlOnLive(FulltextControl)
controlManager.addControlOnLive(BrandsFilterFocusControl)
controlManager.addControlOnLive(ImageUploadPreviewControl)

controlManager.addControlOnLive(EventCallbackControl)
